import Vue from 'vue'
import { SurveyBuilder, SurveyBuilderJson, QuestionsView } from 'vue-survey-builder';

Vue.component('SurveyBuilder', SurveyBuilder);
Vue.component('SurveyBuilderJson', SurveyBuilderJson);
Vue.component('QuestionsView', QuestionsView);
